// Long press on a card (docs/phone-plan.md): shows it with its manual
// actions (discard, beam, junk...), which a tap leaves out. During a prompt
// that offers cards, a long press only shows the card, so it can be read
// before it is picked. An action on the phone shell, for every card it draws
// (`[data-card]`, a uniqueID); a face-down card (`data-facedown`) does nothing.
//
// Until the press turns long, it is the page's: a move scrolls, a quick
// release is a tap. Once it is long the release is not a tap.
import { get } from 'svelte/store';
import { ui } from '../stores.js';
import { inspected, offeredIds } from './phone.js';
import { haptic } from './haptics.js';

const HOLD_MS = 400;
const SLOP = 10;

function swallowClick(){
    const swallow = ev => { ev.stopPropagation(); ev.preventDefault(); };
    window.addEventListener('click', swallow, { capture: true, once: true });
    setTimeout(() => window.removeEventListener('click', swallow, { capture: true }), 400);
}

// use:longPress on the phone's root element.
export function longPress(node){
    let press = null;
    const cardOf = t => {
        const el = t?.closest?.('[data-card]');
        return el && node.contains(el) && el.dataset.card && !('facedown' in el.dataset) ? el : null;
    };
    const end = () => {
        if(!press) return;
        clearTimeout(press.timer);
        press = null;
    };
    function down(e){
        if(e.button > 0 || !e.isPrimary) return;
        const el = cardOf(e.target);
        if(!el) return;
        end();
        press = { x: e.clientX, y: e.clientY, held: false };
        press.timer = setTimeout(() => {
            if(!press) return;
            press.held = true;
            haptic();
            const id = Number(el.dataset.card);
            inspected.set({ id, from: el.getBoundingClientRect(), manual: !offeredIds(get(ui)).length });
        }, HOLD_MS);
    }
    function move(e){
        if(!press || press.held || !e.isPrimary) return;
        if(Math.hypot(e.clientX - press.x, e.clientY - press.y) > SLOP) end();
    }
    function up(e){
        if(!press || !e.isPrimary) return;
        const held = press.held;
        end();
        if(!held) return;
        e.stopPropagation();
        swallowClick(); // the click that follows this release is not a tap
    }
    const contextmenu = e => { if(cardOf(e.target)) e.preventDefault(); };

    node.addEventListener('pointerdown', down, true);
    window.addEventListener('pointermove', move);
    node.addEventListener('pointerup', up, true);
    window.addEventListener('pointercancel', end);
    node.addEventListener('contextmenu', contextmenu);
    return {
        destroy(){
            end();
            node.removeEventListener('pointerdown', down, true);
            window.removeEventListener('pointermove', move);
            node.removeEventListener('pointerup', up, true);
            window.removeEventListener('pointercancel', end);
            node.removeEventListener('contextmenu', contextmenu);
        }
    };
}
